import { frameworkLandingSymbol } from "../../../core/components/landingsymbol/configuration/landingsymbolconfiguration";
import { configGame } from "../../../data/config";


frameworkLandingSymbol.data = {
    "SYMBOL_WIDTH": configGame.SYMBOL_WIDTH,
    "SYMBOL_HEIGHT": configGame.SYMBOL_HEIGHT,
    "SINGLE_SYMBOL_DELAY_IN_ANIM": 1,
    "SYMBOL_ANIMATION_GRP_WISE": false,
    "SYMBOL_ANIMATION_EFFECT": [],

    "symbols": [],
    "symbolsAnimation": [

        {
            "id": "1",
            "name": "symbolF_2",
            "width": 206,
            "height": 308,
            "offsetX": -80,
            "offsetY": -70,

            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 308,
                    "image": "animation_fire_stone_2",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "x": 80,
                    "y": 68,
                    "animations": {
                        "anim": "animation_fire_stone_2",
                        "blast": "animation_fire_stone_2",
                        "landing": "animation_fire_stone_2",

                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_f_2",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 88,
                    "y": 94,
                    "animations": {
                        "anim": "animation_f_2",
                        "blast": "animation_f_2"
                    },
                },

            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "2",
            "name": "symbolF_3",
            "width": 206,
            "height": 206,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 206,
                    "image": "animation_fire_stone_3",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_3",
                        "blast": "animation_fire_stone_3",
                        "landing": "animation_fire_stone_3",
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_f_2",
                    "animationSpeed": 0.2,
                    "scale": 0.75,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 32,
                    "y": 7,
                    "animations": {
                        "anim": "animation_f_2",
                        "blast": "animation_f_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "3",
            "name": "symbolF_4",
            "width": 206,
            "height": 154,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 154,
                    "image": "animation_fire_stone_4",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,


                    "animations": {
                        "anim": "animation_fire_stone_4",
                        "blast": "animation_fire_stone_4",
                        "landing": "animation_fire_stone_4",

                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_f_2",
                    "animationSpeed": 0.2,
                    "scale": 0.55,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 48,
                    "y": 9,
                    "animations": {
                        "anim": "animation_f_2",
                        "blast": "animation_f_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "4",
            "name": "symbolF_5",
            "width": 206,
            "height": 124,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 124,
                    "image": "animation_fire_stone_5",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,


                    "animations": {
                        "anim": "animation_fire_stone_5",
                        "blast": "animation_fire_stone_5",
                        "landing": "animation_fire_stone_5",
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_f_2",
                    "animationSpeed": 0.2,
                    "scale": 0.46,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 60,
                    "y": 2,

                    "animations": {
                        "anim": "animation_f_2",
                        "blast": "animation_f_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "5",
            "name": "symbolF_6",
            "width": 206,
            "height": 104,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 104,
                    "image": "animation_fire_stone_6",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,


                    "animations": {
                        "anim": "animation_fire_stone_6",
                        "blast": "animation_fire_stone_6",
                        "landing": "animation_fire_stone_6",
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_f_2",
                    "animationSpeed": 0.2,
                    "scale": 0.4,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 65,
                    "y": 1,

                    "animations": {
                        "anim": "animation_f_2",
                        "blast": "animation_f_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "6",
            "name": "symbolF_7",
            "width": 206,
            "height": 88,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 88,
                    "image": "animation_fire_stone_7",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,

                    "animations": {
                        "anim": "animation_fire_stone_7",
                        "blast": "animation_fire_stone_7",
                        "landing": "animation_fire_stone_7",
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_f_2",
                    "animationSpeed": 0.2,
                    "scale": 0.32,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 73,
                    "y": 4.5,

                    "animations": {
                        "anim": "animation_f_2",
                        "blast": "animation_f_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },


        {
            "id": "7",
            "name": "symbolI_2",
            "width": 206,
            "height": 308,
            "offsetX": -80,
            "offsetY": -70,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 308,
                    "image": "animation_fire_stone_2",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "x": 80,
                    "y": 68,
                    "animations": {
                        "anim": "animation_fire_stone_2",
                        "blast": "animation_fire_stone_2"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_i_2",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,

                    "x": 88,
                    "y": 94,
                    "animations": {
                        "anim": "animation_i_2",
                        "blast": "animation_i_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "8",
            "name": "symbolI_3",
            "width": 206,
            "height": 206,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 206,
                    "image": "animation_fire_stone_3",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_3",
                        "blast": "animation_fire_stone_3"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_i_2",
                    "animationSpeed": 0.2,
                    "scale": 0.75,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 32,
                    "y": 7,

                    "animations": {
                        "anim": "animation_i_2",
                        "blast": "animation_i_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "9",
            "name": "symbolI_4",
            "width": 206,
            "height": 154,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 154,
                    "image": "animation_fire_stone_4",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_4",
                        "blast": "animation_fire_stone_4"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_i_2",
                    "animationSpeed": 0.2,
                    "scale": 0.55,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 48,
                    "y": 9,
                    "animations": {
                        "anim": "animation_i_2",
                        "blast": "animation_i_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "10",
            "name": "symbolI_5",
            "width": 206,
            "height": 124,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 124,
                    "image": "animation_fire_stone_5",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_5",
                        "blast": "animation_fire_stone_5"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_i_2",
                    "animationSpeed": 0.2,
                    "scale": 0.46,
                    "playing": false,
                    "effectType": "zoomIn",
                    "loop": true,
                    "visible": true,
                    "x": 60,
                    "y": 2,

                    "animations": {
                        "anim": "animation_i_2",
                        "blast": "animation_i_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "11",
            "name": "symbolI_6",
            "width": 206,
            "height": 104,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 104,
                    "image": "animation_fire_stone_6",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_6",
                        "blast": "animation_fire_stone_6"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_i_2",
                    "animationSpeed": 0.2,
                    "scale": 0.4,
                    "playing": false,
                    "effectType": "zoomIn",
                    "loop": true,
                    "visible": true,
                    "x": 65,
                    "y": 1,

                    "animations": {
                        "anim": "animation_i_2",
                        "blast": "animation_i_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "12",
            "name": "symbolI_7",
            "width": 206,
            "height": 88,
            "offsetX": 0,
            "offsetY": 1,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 88,
                    "image": "animation_fire_stone_7",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_7",
                        "blast": "animation_fire_stone_7"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_i_2",
                    "animationSpeed": 0.2,
                    "scale": 0.32,
                    "playing": false,
                    "effectType": "zoomIn",
                    "loop": true,
                    "visible": true,
                    "x": 73,
                    "y": 4.5,

                    "animations": {
                        "anim": "animation_i_2",
                        "blast": "animation_i_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },


        {
            "id": "13",
            "name": "symbolR_2",
            "width": 206,
            "height": 308,
            "offsetX": -80,
            "offsetY": -70,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 308,
                    "image": "animation_fire_stone_2",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "x": 80,
                    "y": 68,
                    "animations": {
                        "anim": "animation_fire_stone_2",
                        "blast": "animation_fire_stone_2"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_r_2",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 88,
                    "y": 94,
                    "animations": {
                        "anim": "animation_r_2",
                        "blast": "animation_r_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "14",
            "name": "symbolR_3",
            "width": 206,
            "height": 206,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 206,
                    "image": "animation_fire_stone_3",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_3",
                        "blast": "animation_fire_stone_3"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_r_2",
                    "animationSpeed": 0.2,
                    "scale": 0.75,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 32,
                    "y": 7,

                    "animations": {
                        "anim": "animation_r_2",
                        "blast": "animation_r_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "15",
            "name": "symbolR_4",
            "width": 206,
            "height": 154,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 154,
                    "image": "animation_fire_stone_4",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_4",
                        "blast": "animation_fire_stone_4"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_r_2",
                    "animationSpeed": 0.2,
                    "scale": 0.55,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 48,
                    "y": 9,
                    "animations": {
                        "anim": "animation_r_2",
                        "blast": "animation_r_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "16",
            "name": "symbolR_5",
            "width": 206,
            "height": 124,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 124,
                    "image": "animation_fire_stone_5",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_5",
                        "blast": "animation_fire_stone_5"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_r_2",
                    "animationSpeed": 0.2,
                    "scale": 0.46,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 60,
                    "y": 2,

                    "animations": {
                        "anim": "animation_r_2",
                        "blast": "animation_r_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "17",
            "name": "symbolR_6",
            "width": 206,
            "height": 104,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 104,
                    "image": "animation_fire_stone_6",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_6",
                        "blast": "animation_fire_stone_6"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_r_2",
                    "animationSpeed": 0.2,
                    "scale": 0.4,
                    "effectType": "zoomIn",
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "x": 65,
                    "y": 1,

                    "animations": {
                        "anim": "animation_r_2",
                        "blast": "animation_r_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "18",
            "name": "symbolR_7",
            "width": 206,
            "height": 88,
            "offsetX": 0,
            "offsetY": 1,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 88,
                    "image": "animation_fire_stone_7",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_7",
                        "blast": "animation_fire_stone_7"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_r_2",
                    "animationSpeed": 0.2,
                    "scale": 0.32,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "effectType": "zoomIn",
                    "x": 73,
                    "y": 4.5,

                    "animations": {
                        "anim": "animation_r_2",
                        "blast": "animation_r_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },


        {
            "id": "19",
            "name": "symbolE_2",
            "width": 206,
            "height": 308,
            "offsetX": -80,
            "offsetY": -70,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 308,
                    "image": "animation_fire_stone_2",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "x": 80,
                    "y": 68,
                    "animations": {
                        "anim": "animation_fire_stone_2",
                        "blast": "animation_fire_stone_2"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_e_2",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 88,
                    "y": 94,
                    "animations": {
                        "anim": "animation_e_2",
                        "blast": "animation_e_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "20",
            "name": "symbolE_3",
            "width": 206,
            "height": 206,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 206,
                    "image": "animation_fire_stone_3",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_3",
                        "blast": "animation_fire_stone_3"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_e_2",
                    "animationSpeed": 0.2,
                    "scale": 0.75,
                    "effectType": "zoomIn",
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "x": 32,
                    "y": 7,

                    "animations": {
                        "anim": "animation_e_2",
                        "blast": "animation_e_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "21",
            "name": "symbolE_4",
            "width": 206,
            "height": 154,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 154,
                    "image": "animation_fire_stone_4",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_4",
                        "blast": "animation_fire_stone_4"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_e_2",
                    "animationSpeed": 0.2,
                    "scale": 0.55,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 48,
                    "y": 9,
                    "animations": {
                        "anim": "animation_e_2",
                        "blast": "animation_e_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "22",
            "name": "symbolE_5",
            "width": 206,
            "height": 124,
            "offsetX": 0,
            "offsetY": 5,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 124,
                    "image": "animation_fire_stone_5",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_5",
                        "blast": "animation_fire_stone_5"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_e_2",
                    "animationSpeed": 0.2,
                    "scale": 0.46,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 60,
                    "y": 2,

                    "animations": {
                        "anim": "animation_e_2",
                        "blast": "animation_e_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "23",
            "name": "symbolE_6",
            "width": 206,
            "height": 104,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 104,
                    "image": "animation_fire_stone_6",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_6",
                        "blast": "animation_fire_stone_6"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_e_2",
                    "animationSpeed": 0.2,
                    "scale": 0.4,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 65,
                    "y": 1,

                    "animations": {
                        "anim": "animation_e_2",
                        "blast": "animation_e_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "24",
            "name": "symbolE_7",
            "width": 206,
            "height": 88,
            "offsetX": 0,
            "offsetY": 1,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 88,
                    "image": "animation_fire_stone_7",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_7",
                        "blast": "animation_fire_stone_7"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_e_2",
                    "animationSpeed": 0.2,
                    "scale": 0.32,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 73,
                    "y": 4.5,

                    "animations": {
                        "anim": "animation_e_2",
                        "blast": "animation_e_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },


        {
            "id": "25",
            "name": "symbolExtraScatter_2",
            "width": 206,
            "height": 308,
            "offsetX": -80,
            "offsetY": -70,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 308,
                    "image": "animation_fire_stone_2",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "x": 80,
                    "y": 68,
                    "animations": {
                        "anim": "animation_fire_stone_2",
                        "blast": "animation_fire_stone_2"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_extraScatter_2",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 80,
                    "y": 82,
                    "animations": {
                        "anim": "animation_extraScatter_2",
                        "blast": "animation_extraScatter_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "26",
            "name": "symbolExtraScatter_3",
            "width": 206,
            "height": 206,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 206,
                    "image": "animation_fire_stone_3",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,
                    "animations": {
                        "anim": "animation_fire_stone_3",
                        "blast": "animation_fire_stone_3"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_extraScatter_2",
                    "animationSpeed": 0.2,
                    "scale": 0.90,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 12,
                    "y": -20,
                    "animations": {
                        "anim": "animation_extraScatter_2",
                        "blast": "animation_extraScatter_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "27",
            "name": "symbolExtraScatter_4",
            "width": 206,
            "height": 154,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 154,
                    "image": "animation_fire_stone_4",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,


                    "animations": {
                        "anim": "animation_fire_stone_4",
                        "blast": "animation_fire_stone_4"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_extraScatter_2",
                    "animationSpeed": 0.2,
                    "scale": 0.85,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 18,
                    "y": -40,
                    "animations": {
                        "anim": "animation_extraScatter_2",
                        "blast": "animation_extraScatter_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "28",
            "name": "symbolExtraScatter_5",
            "width": 206,
            "height": 124,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 124,
                    "image": "animation_fire_stone_5",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,


                    "animations": {
                        "anim": "animation_fire_stone_5",
                        "blast": "animation_fire_stone_5"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_extraScatter_2",
                    "animationSpeed": 0.2,
                    "scale": 0.70,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 30,
                    "y": -32,

                    "animations": {
                        "anim": "animation_extraScatter_2",
                        "blast": "animation_extraScatter_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "29",
            "name": "symbolExtraScatter_6",
            "width": 206,
            "height": 104,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 104,
                    "image": "animation_fire_stone_6",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,


                    "animations": {
                        "anim": "animation_fire_stone_6",
                        "blast": "animation_fire_stone_6"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_extraScatter_2",
                    "animationSpeed": 0.2,
                    "scale": 0.65,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 38,
                    "y": -36,

                    "animations": {
                        "anim": "animation_extraScatter_2",
                        "blast": "animation_extraScatter_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },
        {
            "id": "30",
            "name": "symbolExtraScatter_7",
            "width": 206,
            "height": 88,
            "offsetX": 0,
            "offsetY": 0,
            "child": [

                {
                    "type": "Animation",
                    "width": 206,
                    "height": 88,
                    "image": "animation_fire_stone_7",
                    "animationSpeed": 0.2,
                    "playing": false,
                    "loop": true,
                    "visible": true,

                    "animations": {
                        "anim": "animation_fire_stone_7",
                        "blast": "animation_fire_stone_7"
                    },
                },
                {
                    "type": "Animation",
                    "width": 190,
                    "height": 260,
                    "image": "animation_extraScatter_2",
                    "animationSpeed": 0.2,
                    "scale": 0.55,
                    "playing": false,
                    "loop": true,
                    "effectType": "zoomIn",
                    "visible": true,
                    "x": 48,
                    "y": -32,

                    "animations": {
                        "anim": "animation_extraScatter_2",
                        "blast": "animation_extraScatter_2"
                    },
                },
            ],
            "loop": true,
            "visible": true,
        },

    ],

}